// Polyfills
import '@babel/polyfill';
import 'url-polyfill';
import 'isomorphic-fetch';
import 'custom-event-polyfill';
import 'blueimp-canvas-to-blob';
import 'intersection-observer';
import 'delayed-scroll-restoration-polyfill';

// Library CSS
import 'cropperjs/dist/cropper.css';
import 'flatpickr/dist/flatpickr.css';
import 'draft-js/dist/Draft.css';
import 'draft-js-static-toolbar-plugin/lib/plugin.css';
import 'video.js/dist/video-js.css';
import 'stream-chat-react/dist/css/index.css';

import React from 'react';
import ReactDOM from 'react-dom';
import * as yup from 'yup';
import * as Sentry from '@sentry/react';
import { datadogRum } from '@datadog/browser-rum';

import App from 'startup/App';

import { SENTRY_DSN, NODE_ENV, DATADOG_APP_ID, DATADOG_CLIENT_TOKEN } from 'settings';

// Extend Yup
yup.addMethod(yup.string, 'hasHtml', function(message) {
  const emptyHtml = '<p>&nbsp;</p>';
  // @ts-ignore
  return this.test('has-html', message, value => {
    return value !== emptyHtml;
  });
});

// Custom Error Types for GraphQL
class GraphQLError extends Error {
  constructor(message: any) {
    super(message);
    this.name = 'GraphQLError';
  }
}

// tslint:disable-next-line:max-classes-per-file
class NetworkError extends Error {
  constructor(message: any) {
    super(message);
    this.name = 'NetworkError';
  }
}

window.GraphQLError = GraphQLError;
window.NetworkError = NetworkError;

if (SENTRY_DSN) {
  Sentry.init({ dsn: SENTRY_DSN, environment: NODE_ENV });
}

if (DATADOG_APP_ID) {
  datadogRum.init({
    applicationId: DATADOG_APP_ID,
    clientToken: DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: `frontend-${NODE_ENV}`,
    env: NODE_ENV,
    sampleRate: 100,
    trackInteractions: true,
  });
}

ReactDOM.render(<App />, document.getElementById('root'));
